(function () {
  const LOADING_CLASS = "variant-gallery-loading";
  const READY_CLASS = "variant-gallery-ready";

  function normalizeValue(v) {
    return (v || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/\s*\+\s*/g, "+")
      .trim();
  }

  function compactValue(v) {
    return normalizeValue(v).replace(/[^a-z0-9]+/g, "");
  }

  function normalizeShapeValue(v) {
    return compactValue(v)
      .replace(/lefthandfacing/g, "lhf")
      .replace(/righthandfacing/g, "rhf");
  }

  function shapeMatches(mappedShape, selectedShape) {
    const mapped = normalizeShapeValue(mappedShape);
    const selected = normalizeShapeValue(selectedShape);

    if (!selected || mapped === selected) return true;

    const isShapePart =
      selected.includes("shape") ||
      selected.includes("lhf") ||
      selected.includes("rhf");

    return isShapePart && mapped.includes(selected);
  }

  // Product media mapping:
  // Material-Shape-Colour_Sequence
  // Example: Chenille-ushape-LightGrey_7
  // A blank suffix, _0, or _1 is treated as the first image.
  function parseAltMapping(value) {
    const rawValue = String(value || "")
      .trim()
      .split("/")
      .pop()
      .split("?")[0]
      .replace(/\.[a-z0-9]+$/i, "")
      .replace(
        /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
        ""
      );
    if (!rawValue) return null;

    // Shopify can append a unique file ID after our sequence, for example:
    // chenille-2seater-lightgrey_1_fb953e63-9934-4beb-96c3-d9e08c5a275
    // Read the first numeric suffix as the sequence even when more filename
    // metadata follows it.
    const suffixMatch = rawValue.match(/_(\d+)(?=_|$)/);
    const mappingValue = suffixMatch
      ? rawValue.slice(0, suffixMatch.index)
      : rawValue;

    const tokens = mappingValue
      .split("-")
      .map(compactValue)
      .filter(Boolean);

    if (tokens.length < 3) return null;

    const suppliedSequence = suffixMatch ? Number(suffixMatch[1]) : 1;

    return {
      material: tokens[0],
      shape: tokens[1],
      colour: tokens.slice(2).join(""),
      sequence: suppliedSequence <= 1 ? 1 : suppliedSequence,
    };
  }

  function mappedAltMatches(alt, colorValue, materialValue, shapeValue) {
    const mapping = parseAltMapping(alt);
    if (!mapping) return null;

    const color = compactValue(colorValue);
    const material = compactValue(materialValue);
    const shape = compactValue(shapeValue);

    return (
      (!material || mapping.material === material) &&
      shapeMatches(mapping.shape, shape) &&
      (!color || mapping.colour === color)
    );
  }

  function valueMatches(text, value) {
    const normalizedText = normalizeValue(text);
    const normalizedValue = normalizeValue(value);

    if (!normalizedValue) return true;

    return (
      normalizedText.includes(normalizedValue) ||
      compactValue(normalizedText).includes(compactValue(normalizedValue))
    );
  }

  function addLoadingState() {
    document.documentElement.classList.add(LOADING_CLASS);
    document.documentElement.classList.remove(READY_CLASS);
  }

  function markGalleryReady() {
    document.documentElement.classList.remove(LOADING_CLASS);
    document.documentElement.classList.add(READY_CLASS);
  }

  function getDrawer() {
    return document.getElementById("variantDrawer");
  }

  function moveDrawerToBody() {
    const drawer = getDrawer();
    if (!drawer) return;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  function lockPage() {
    document.documentElement.classList.add("overflow-hidden");
    document.body.classList.add("overflow-hidden");
  }

  function unlockPage() {
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");
  }

  function getGallerySlides() {
    return Array.from(
      document.querySelectorAll(
        "[data-gallery] [data-swiper-slide], .product__media-item, .swiper-slide"
      )
    );
  }

  function getThumbItems() {
    return Array.from(
      document.querySelectorAll(
        "[data-thumbs] .thumbs-list-item, .thumbnail-list__item, .product__media-thumbnail"
      )
    );
  }

  function getImgFromNode(node) {
    return node ? node.querySelector("img") : null;
  }

  function getMediaGallery() {
    return document.querySelector("gallery-section[data-product-page]") ||
      document.querySelector("gallery-section");
  }

  function getGalleryOptionsFromItem(item) {
    if (!item) return [];

    return [
      item.dataset.galleryType || item.dataset.option1 || "",
      item.dataset.galleryColor || item.dataset.option2 || "",
      item.dataset.galleryStyle || item.dataset.option3 || "",
    ].filter(Boolean);
  }

  function findBestMatchingSlide(colorValue, typeValue, styleValue) {
    const color = normalizeValue(colorValue);
    const type = normalizeValue(typeValue);
    const style = normalizeValue(styleValue);

    const slides = getGallerySlides();
    let best = null;
    let bestScore = -1;

    slides.forEach((slide) => {
      const img = getImgFromNode(slide);
      if (!img) return;

      let alt = normalizeValue(img.getAttribute("alt"));
      if (!alt || !parseAltMapping(alt)) {
        const src = img.getAttribute("src") || img.getAttribute("data-src") || "";
        if (src && parseAltMapping(src)) {
          alt = normalizeValue(src);
        }
      }
      if (!alt) return;

      const mappedMatch = mappedAltMatches(alt, color, type, style);
      const colorMatch = mappedMatch === null ? valueMatches(alt, color) : mappedMatch;
      const typeMatch = mappedMatch === null ? valueMatches(alt, type) : mappedMatch;
      const styleMatch = mappedMatch === null ? valueMatches(alt, style) : mappedMatch;

      if (!colorMatch || !typeMatch || !styleMatch) return;

      const mapping = parseAltMapping(alt);
      let score = mapping ? 1000 - mapping.sequence : 0;

      if (color && valueMatches(alt, color)) score += 2;
      if (type && valueMatches(alt, type)) score += 2;
      if (style && valueMatches(alt, style)) score += 4;

      if (valueMatches(alt, "room")) score += 1;
      if (valueMatches(alt, "sofa")) score += 1;
      if (valueMatches(alt, "front")) score += 1;
      if (valueMatches(alt, "angle")) score += 0.5;
      if (valueMatches(alt, "fabric")) score -= 2;
      if (valueMatches(alt, "swatch")) score -= 2;

      if (score > bestScore) {
        best = {
          slide,
          img,
          alt,
          score,
        };
        bestScore = score;
      }
    });

    return best;
  }

  function applyGalleryFilter(colorValue, typeValue, styleValue) {
    const color = normalizeValue(colorValue);
    const type = normalizeValue(typeValue);
    const style = normalizeValue(styleValue);

    const slides = getGallerySlides();
    let firstMatch = null;

    slides.forEach((slide) => {
      if (
        slide.dataset.alwaysShow === "true" ||
        slide.querySelector("[data-always-show='true']") != null ||
        slide.querySelector("video") != null
      ) {
        slide.style.display = "";
        return;
      }

      const img = getImgFromNode(slide);

      if (!img) {
        slide.style.display = "none";
        return;
      }

      const alt = normalizeValue(img.getAttribute("alt"));

      const mappedMatch = mappedAltMatches(alt, color, type, style);
      const colorMatch = mappedMatch === null ? valueMatches(alt, color) : mappedMatch;
      const typeMatch = mappedMatch === null ? valueMatches(alt, type) : mappedMatch;
      const styleMatch = mappedMatch === null ? valueMatches(alt, style) : mappedMatch;

      const show = !!alt && colorMatch && typeMatch && styleMatch;

      slide.style.display = show ? "" : "none";

      if (show && !firstMatch) {
        firstMatch = {
          slide,
          img,
          alt,
        };
      }
    });

    return findBestMatchingSlide(colorValue, typeValue, styleValue) || firstMatch;
  }

  function applyThumbFilter(colorValue, typeValue, styleValue) {
    const color = normalizeValue(colorValue);
    const type = normalizeValue(typeValue);
    const style = normalizeValue(styleValue);

    const thumbs = getThumbItems();
    let firstVisibleThumb = null;

    thumbs.forEach((thumb) => {
      if (
        thumb.dataset.alwaysShow === "true" ||
        thumb.querySelector("[data-always-show='true']") != null ||
        thumb.querySelector("video") != null
      ) {
        thumb.style.display = "";
        return;
      }

      const img = getImgFromNode(thumb);

      if (!img) {
        thumb.style.display = "none";
        return;
      }

      const alt = normalizeValue(img.getAttribute("alt"));

      const mappedMatch = mappedAltMatches(alt, color, type, style);
      const colorMatch = mappedMatch === null ? valueMatches(alt, color) : mappedMatch;
      const typeMatch = mappedMatch === null ? valueMatches(alt, type) : mappedMatch;
      const styleMatch = mappedMatch === null ? valueMatches(alt, style) : mappedMatch;

      const show = !!alt && colorMatch && typeMatch && styleMatch;

      thumb.style.display = show ? "" : "none";

      if (show && !firstVisibleThumb) {
        firstVisibleThumb = thumb;
      }
    });

    return firstVisibleThumb;
  }

  function setMainImageFromBestMatch(best) {
    if (!best || !best.img) return;

    const mainImage =
      document.querySelector(
        '[data-gallery] [data-swiper-slide]:not([style*="display: none"]) img'
      ) ||
      document.querySelector(".product__media img") ||
      document.querySelector(".product-media-container img") ||
      document.querySelector(".product-gallery img");

    if (mainImage) {
      const newSrc = best.img.currentSrc || best.img.src;
      mainImage.src = newSrc;
      mainImage.srcset = "";

      if (best.img.getAttribute("alt")) {
        mainImage.setAttribute("alt", best.img.getAttribute("alt"));
      }
    }
  }

  function clickThumb(thumb) {
    if (!thumb) return;

    const clickable = thumb.querySelector("button, a") || thumb;
    clickable.click();
  }

  function updateDrawerPreview(item) {
    const hero = document.getElementById("variantDrawerHero");
    if (!hero || !item) return;

    const best = findBestMatchingSlide(
      item.dataset.galleryColor,
      item.dataset.galleryType,
      item.dataset.galleryStyle
    );

    if (best && best.img) {
      hero.src = best.img.currentSrc || best.img.src;

      if (best.img.getAttribute("alt")) {
        hero.setAttribute("alt", best.img.getAttribute("alt"));
      }

      return;
    }

    if (item.dataset.image) {
      hero.src = item.dataset.image;
    }
  }

  function syncSelectedCard(item) {
    if (!item) return;

    const label = document.getElementById("selectedVariantLabel");
    if (label) label.textContent = item.dataset.title || "";

    const cardTitle = document.getElementById("selectedVariantCardTitle");
    if (cardTitle) {
      cardTitle.textContent =
        item.dataset.galleryColor ||
        item.dataset.option2 ||
        item.dataset.title ||
        "";
    }

    const cardMaterial = document.getElementById("selectedVariantCardMaterial");
    const material = item.dataset.galleryType || item.dataset.option1 || "";
    if (cardMaterial) {
      const style = item.dataset.galleryStyle || item.dataset.option3 || "";
      cardMaterial.textContent = style ? material + " / " + style : material;
    }

    const cardFabricBadge = document.querySelectorAll(".js-pc-fabric-name");
    if (cardFabricBadge.length && material) {
      cardFabricBadge.forEach((el) => {
        el.textContent = material;
      });
    }

    const cardDelivery = document.getElementById("selectedVariantCardDelivery");
    if (cardDelivery) {
      cardDelivery.textContent = item.dataset.delivery || "";
    }

    const cardImage = document.getElementById("selectedVariantCardImage");
    if (cardImage) {
      const best = findBestMatchingSlide(
        item.dataset.galleryColor,
        item.dataset.galleryType,
        item.dataset.galleryStyle
      );

      if (best && best.img) {
        cardImage.src = best.img.currentSrc || best.img.src;
        if (best.img.getAttribute("alt")) {
          cardImage.setAttribute("alt", best.img.getAttribute("alt"));
        }
      } else if (item.dataset.image) {
        cardImage.src = item.dataset.image;
      }
    }
  }

  function syncMainProductForm(variantId) {
    const inputs = document.querySelectorAll(
      'form[action*="/cart/add"] input[name="id"], form[data-type="add-to-cart-form"] input[name="id"], input[name="id"]'
    );

    inputs.forEach((input) => {
      input.value = variantId;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function syncMainProductMedia(item) {
    if (!item) return;

    addLoadingState();

    const mediaGallery = getMediaGallery();
    const options = getGalleryOptionsFromItem(item);

    const runGalleryFilter = (gallery) => {
      if (gallery?.filterSlides) {
        const mediaId = gallery.getBestMediaIdForOptions
          ? gallery.getBestMediaIdForOptions(options, "", true)
          : "";
        gallery.filterSlides(options, mediaId, true);
        window.setTimeout(markGalleryReady, 350);
        return true;
      }
      return false;
    };

    if (runGalleryFilter(mediaGallery)) {
      return;
    }

    if (
      window.customElements?.whenDefined &&
      mediaGallery?.tagName?.toLowerCase() === "gallery-section"
    ) {
      window.customElements.whenDefined("gallery-section").then(() => {
        const updatedGallery = getMediaGallery();
        if (!runGalleryFilter(updatedGallery)) {
          markGalleryReady();
        }
      });
      return;
    }

    const best = applyGalleryFilter(
      item.dataset.galleryColor,
      item.dataset.galleryType,
      item.dataset.galleryStyle
    );

    const firstVisibleThumb = applyThumbFilter(
      item.dataset.galleryColor,
      item.dataset.galleryType,
      item.dataset.galleryStyle
    );

    if (firstVisibleThumb) {
      clickThumb(firstVisibleThumb);
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        markGalleryReady();
      });
    });
  }

  function updateUrlVariant(variantId) {
    const url = new URL(window.location.href);
    if (url.searchParams.has("variant")) {
      url.searchParams.delete("variant");
      const cleanUrl = url.search
        ? `${url.pathname}${url.search}`
        : url.pathname;
      window.history.replaceState({}, "", cleanUrl);
    }
  }

  window.openVariantDrawer = function () {
    const drawer = getDrawer();
    if (!drawer) return;

    moveDrawerToBody();
    drawer.style.display = "flex";

    requestAnimationFrame(() => {
      drawer.classList.add("is-open");
      lockPage();
    });
  };

  window.closeVariantDrawer = function () {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove("is-open");
    unlockPage();

    setTimeout(() => {
      if (!drawer.classList.contains("is-open")) {
        drawer.style.display = "none";
      }
    }, 420);
  };

  window.selectVariantDrawerItem = function (item) {
    document.querySelectorAll(".variant-drawer__item").forEach((el) => {
      el.classList.remove("is-active");
    });

    item.classList.add("is-active");
    window.variantDrawerSelectedId = item.dataset.variantId || "";

    updateDrawerPreview(item);
  };

  window.filterVariantDrawerItems = function () {
    const material =
      document.getElementById("variantDrawerMaterialFilter")?.value || "";
    const colour =
      document.getElementById("variantDrawerColorFilter")?.value || "";
    const style =
      document.getElementById("variantDrawerStyleFilter")?.value || "";

    let visibleItemCount = 0;

    document.querySelectorAll(".variant-drawer__item").forEach((item) => {
      const materialMatch = !material || item.dataset.material === material;
      const colourMatch = !colour || item.dataset.colour === colour;
      const styleMatch = !style || item.dataset.style === style;
      const isVisible = materialMatch && colourMatch && styleMatch;

      item.style.display = isVisible ? "" : "none";
      if (isVisible) visibleItemCount += 1;
    });

    document.querySelectorAll(".variant-drawer__group").forEach((group) => {
      const visibleItems = group.querySelectorAll(
        '.variant-drawer__item:not([style*="display: none"])'
      );

      group.style.display = visibleItems.length ? "" : "none";
    });

    const emptyState = document.getElementById("variantDrawerEmptyState");
    if (emptyState) {
      emptyState.hidden = visibleItemCount > 0;
    }
  };

  window.confirmVariantDrawerSelection = function () {
    const selectedItem = document.querySelector(".variant-drawer__item.is-active");
    if (!selectedItem) return;

    const variantId = selectedItem.dataset.variantId;
    if (!variantId) return;

    window.variantDrawerSelectedId = variantId;

    syncMainProductForm(variantId);
    syncMainProductMedia(selectedItem);
    syncSelectedCard(selectedItem);
    updateUrlVariant(variantId);

    document.dispatchEvent(
      new CustomEvent("variant:changed", {
        detail: {
          variantId: variantId,
        },
      })
    );

    window.closeVariantDrawer();
  };

  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".variant-drawer__backdrop") ||
      e.target.closest('[data-action="close-variant-drawer"]')
    ) {
      window.closeVariantDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      window.closeVariantDrawer();
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    addLoadingState();
    moveDrawerToBody();

    const drawer = getDrawer();
    if (drawer) {
      drawer.style.display = "none";
    }

    const initiallySelectedItem = document.querySelector(
      ".variant-drawer__item.is-active"
    );

    if (initiallySelectedItem) {
      window.variantDrawerSelectedId =
        window.variantDrawerConfig?.selectedVariantId ||
        initiallySelectedItem.dataset.variantId ||
        "";

      updateDrawerPreview(initiallySelectedItem);
      syncSelectedCard(initiallySelectedItem);
      syncMainProductMedia(initiallySelectedItem);
    } else {
      markGalleryReady();
    }
  });
})();
